var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":_vm.link}},[_c('div',{staticClass:"profile_card my-5"},[_c('div',{staticClass:"profile_card_component"},[_c('div',{staticClass:"icon",style:({ background: _vm.bgColor })},[_c('span',{style:({ color: _vm.color })},[_c('i',{class:[_vm.icon]})])]),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }